import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-appointment-bookapt',
  templateUrl: './appointment-bookapt.component.html',
  styleUrls: ['./appointment-bookapt.component.css']
})
export class AppointmentBookaptComponent {

  @Input() disabled = false;
  @Output() onBookAppointment: EventEmitter<Date> = new EventEmitter<Date>();

  constructor() { }

  btnBookAppointment(e) {
    this.onBookAppointment.emit(new Date());
  }
}
